import React, { ReactNode } from 'react';
import { palettes } from '@indigo-ag/component-module';

import { CURRENCY_SYMBOL } from 'shared';

export const BrazilCurrencySymbol = (): ReactNode => (
  <span style={{ color: palettes.coastal.core.mediumBlue, fontWeight: 500 }}>{CURRENCY_SYMBOL.BR}</span>
);
